import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux'
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import configureStore from './store/configureStore'

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
        <Provider store={configureStore()}>
            <App/>
        </Provider>);

serviceWorker.register();
